import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS, STATS } from "@/data/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Reviews() {
  return (
    <section className="relative overflow-hidden bg-sand py-24 md:py-32" data-testid="reviews-section">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <Overline className="text-sun">Avaliações</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-brand-navy sm:text-5xl">
            Quem mergulhou já quer voltar...
          </h2>
        </Reveal>

        {/* Stats */}
        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="rounded-3xl bg-white p-8 text-center shadow-xl shadow-ocean-mid/10">
                <p className="font-display text-4xl font-extrabold text-ocean-mid sm:text-5xl">{s.value}</p>
                <p className="mt-2 text-sm font-medium text-muted-foreground">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
              className="flex flex-col rounded-3xl bg-white p-6 shadow-xl shadow-ocean-deep/10"
              data-testid={`review-${i}`}
            >
              <div className="mb-3 flex items-center justify-between">
                <div className="flex">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-sun text-sun" />
                  ))}
                </div>
                <span className="text-xs font-bold text-muted-foreground">Google</span>
              </div>
              <Quote className="h-6 w-6 text-ocean-mid/40" />
              <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-navy/90">“{r.quote}”</p>
              <div className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4">
                <span
                  className="flex h-11 w-11 items-center justify-center rounded-full font-display text-sm font-extrabold text-white"
                  style={{ backgroundColor: r.color }}
                >
                  {r.initials}
                </span>
                <div>
                  <p className="text-sm font-bold text-brand-navy">{r.name}</p>
                  <p className="text-xs text-muted-foreground">{r.city} · Compra verificada</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
